// extracted by mini-css-extract-plugin
export default {"container":"Comment_container__k3PIS","comment":"Comment_comment__XeSaq"};